import { PageLayoutMenuFooter } from '@components/layouts/PageLayoutMenuFooter';
import { ValidSessionRoute } from '@ferreri/minato-auth-react';

import Home from '@modules/home/Home';
import { PAGE_TITLE } from '@utils/pageTitle';

export default function HomePage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayoutMenuFooter title={PAGE_TITLE.home}>
          <Home />
        </PageLayoutMenuFooter>
      }
    >
      <PageLayoutMenuFooter title={PAGE_TITLE.home}>
        <Home />
      </PageLayoutMenuFooter>
    </ValidSessionRoute>
  );
}
